import { doLogout } from "actions/authAction";
import { BASE_URL } from "actions/constant";
export const DATA_PENGADUAN = "DATA_PENGADUAN";

const getDataPengaduan = (bool, value, err, success) => {
  return {
    type: DATA_PENGADUAN,
    load: bool,
    error: { stat: err?.stat || false, msg: err?.msg || "" },
    val: value.data,
    success: success || false,
  };
};

export const DataPengaduan = (data) => {
  return (dispatch) => {
    dispatch(getDataPengaduan(true, { data: {} }));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      // if (data === undefined){
      //   data = {payment_channel : 1}
      // }else{
      //   data.payment_channel = 1
      // }
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `pengaduan/dashboard`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === 200) {
          dispatch(getDataPengaduan(false, res, {}, true));
        } else {
          dispatch(getDataPengaduan(false, res, { stat: true, msg: res.msg }));
        }
      })
      .catch((error) => {
        const { response } = error;
        const resp = response ? response.data : error.message;
        dispatch(
          getDataPengaduan(false, { data: {} }, { stat: true, msg: resp })
        );
      });
  };
};
